<template>
  <div class="m-box">
    <van-form @submit="onSubmit">
      <div class="x-input-no x-bottom-15">
        <van-field
            maxlength="20"
            v-model.trim="form.realName"
            placeholder="请输入姓名"
            :rules="[{ required: true, message: '' }]"
        />
      </div>
      <div class="x-input-no x-bottom-15">
        <van-field
            v-model="regionName"
            clickable
            readonly
            placeholder="请选择证件类型"
            :rules="[{ required: true, message: '' }]"
            @click="areaPicker = true"
        >
          <template #right-icon>
            <van-icon name="arrow-down"/>
          </template>
        </van-field>
        <van-popup v-model="areaPicker" position="bottom">
          <van-picker show-toolbar value-key="test" title="选择证件类型" :columns="columns" @cancel="areaPicker = false" @confirm="chooseArea"/>
        </van-popup>
      </div>
      <div class="x-input-no x-bottom-15">
        <van-field
            v-model.trim="cardComputed"
            placeholder="请输证件号码"
            :maxlength="form.region==1 ? 18 : form.region== 4 ? 9 : 20"
            :rules="[{ required: true, message: '' }]"
        />
      </div>
      <div class="x-input-no x-bottom-15" v-if="showDept==1">
        <van-field v-model="deptName" clickable readonly placeholder="请选择部门/年级" :rules="[{ required: true, message: '' }]" @click="deptPicker = true">
          <template #right-icon>
            <van-icon name="arrow-down"/>
          </template>
        </van-field>
        <van-popup v-model="deptPicker" position="bottom">
          <van-picker show-toolbar value-key="deptName" title="选择部门/年级" :columns="deptList" @cancel="deptPicker = false" @confirm="chooseDept"/>
        </van-popup>
      </div>
      <div class="x-input-no x-bottom-15" v-if="type==1">
        <van-field v-model="userTypeName" clickable readonly placeholder="请选择考生类型" :rules="[{ required: true, message: '' }]" @click="typePicker = true">
          <template #right-icon>
            <van-icon name="arrow-down"/>
          </template>
        </van-field>
        <van-popup v-model="typePicker" position="bottom">
          <van-picker show-toolbar value-key="userType" title="选择考生类型" :columns="columnType" @cancel="typePicker = false" @confirm="chooseType"/>
        </van-popup>
        <!--<select-model v-model="typePicker" :modelList="columnType" valueKey="userType" @confirm="chooseType"/>-->
      </div>
      <div class="x-input-no x-bottom-15" v-if="major==1">
        <van-field v-model="userMajorName" clickable readonly placeholder="请选择考生专业" :rules="[{ required: true, message: '' }]" @click="examPicker = true">
          <template #right-icon>
            <van-icon name="arrow-down"/>
          </template>
        </van-field>
        <van-popup v-model="examPicker" position="bottom">
          <van-picker show-toolbar value-key="majorName" title="选择考生专业" :columns="columnExam" @cancel="examPicker = false" @confirm="chooseExam"/>
        </van-popup>
      </div>
      <div class="x-input-no x-bottom-15" v-if="showSubject==1">
        <van-field v-model="userSubjectName" clickable readonly placeholder="请选择考生学科" :rules="[{ required: true, message: '' }]" @click="subjectPicker = true">
          <template #right-icon>
            <van-icon name="arrow-down"/>
          </template>
        </van-field>
        <van-popup v-model="subjectPicker" position="bottom">
          <van-picker show-toolbar value-key="name" title="选择考生学科" :columns="columnSub" @cancel="subjectPicker = false" @confirm="chooseSub"/>
        </van-popup>
      </div>
      <div class="x-input-no x-bottom-15" v-if="fileOnOff==1">
        <van-uploader style="position: relative" :after-read="afterRead" accept="file" :before-read="beforeRead">
          <van-field
              maxlength="20"
              v-model="fileStr"
              placeholder="请上传报名材料"
              readonly
              :rules="[{ required: fileNotNull==1 ?  true : false, message: '' }]"
          >
          </van-field>
          <van-icon class="m-icon" :name="fileStr ? 'cross' : 'plus'" @click.stop="del()"/>
        </van-uploader>
      </div>
      <div class="x-flex-center">
        <van-button block class="x-btn-log m-btn" native-type="submit">
           下一步 <van-icon name="arrow" />
        </van-button>
      </div>
    </van-form>
    <!--<div @click="isShow =!isShow">ssss</div>-->
    <!--<select-model v-model="isShow" :modelList="columns" valueKey="test" @confirm="ceShi"/>-->
  </div>
</template>

<script>
  import selectModel from '@/components/downModel/select-model'
//  const citys = [
//    {
//      text: '浙江',
//      value:1,
//      children: [
//        {
//          text: '杭州',
//          value:2,
//          children: [{ text: '西湖区',value:4 }, { text: '余杭区',value:5 }],
//        },
//        {
//          text: '温州',
//          value:3,
//          children: [{ text: '鹿城区',value:6 }, { text: '瓯海区',value:7 }],
//        },
//      ],
//    }
//  ]
  export default {
    components: {selectModel},
      props:{
        isRegister:{
          type:Number,
          default:0
        }
      },
      computed:{
        cardComputed:{
          get: function () {
            return this.form.idCardNum
          },
          set: function (val) {
            this.form.idCardNum = val.toUpperCase()
          }
        }
      },
      data () {
      return {
        isShow:false,
        form: {
          realName:'',
          region:'',
          idCardNum:'',
          userTypeId:'',
          deptId:'',
          userMajorId:'',
          userSubjectId:'',
          attachPath:''
        },
        regionName:'',
        userTypeName:'',
        userMajorName:'',
        userSubjectName:'',
        deptName:'',
        checked:false,
        areaPicker:false,
        typePicker:false,
        examPicker:false,
        deptPicker:false,
        subjectPicker:false,
        columns: [
          {test:'居民身份证',value:'1'},
          {test:'港澳居民来往内地通行证',value:'2'},
          {test:'台湾居民来往大陆通行证',value:'3'},
          {test:'护照',value:'4'}
        ],
        columnType: [],
        columnExam: [],
        columnSub:[],
        type: '',
        major: '',
        showSubject:'',
        showDept:'',
        showRegister:'',
        fileOnOff: '',
        fileNotNull: '',
        deptList:[],
        fileStr:''
      }
    },
    created () {
      this.getTypeStu()
      this.getTenant()
    },
    methods: {
      ceShi(e){
        console.log(e)
        console.log(this.columns)
      },
      onSubmit(){
        let url = ''
        if(this.showRegister==1&&this.isRegister==1){
          url = 'app/userInfo/checkInsertOne'
        }
        if(this.showRegister==2&&this.isRegister==2){
          url = 'app/userInfo/applyCheckInsertOne'
        }
        if(!url){
          let msg = this.isRegister==1 ? '请在管理端打开注册功能！' : '请在管理端打开申请注册功能！'
          this.utils.toastNone(msg)
          return
        }
        if(this.form.region==1){
          let reg = /(^\d{15}$)|(^\d{17}([0-9]|X)$)/ //验证身份证号码的正则
          if(!reg.test(this.form.idCardNum)){
            this.utils.toastNone("身份证格式不正确！")
            return
          }
        }
        if(this.form.region==4){
          let reg = /^[0-9a-zA-Z]{9}/
          if(!reg.test(this.form.idCardNum)){
            this.utils.toastNone("护照格式不正确！")
            return
          }
        }
        console.log(this.form)
        this.http.postRequest({
          url:url,
          msg:this.form,
          success:(res)=>{
            if(this.isRegister==1){
              this.$emit('isOK',2)
            } else {
              this.$emit('isOK',2,this.form.idCardNum)
            }

          }
        },true)

      },
      chooseArea(i){
        this.regionName = i.test
        this.form.region = i.value
        this.areaPicker = false
        this.form.idCardNum = ''
      },
      chooseType(i){
        this.typePicker = false
        this.form.userTypeId=i.id
        this.userTypeName=i.userType
        this.form.userMajorId = ''
        this.userMajorName = ''
        this.getMajor(i.id)
      },
      chooseExam(i){
        this.form.userMajorId=i.id
        this.userMajorName=i.majorName
        this.examPicker = false
        if(this.showSubject==1){
          this.getSub(i.id)
        }
      },
      chooseSub(i){
        this.subjectPicker = false
        this.form.userSubjectId=i.id
        this.userSubjectName=i.name
      },
      chooseDept(i){
        this.form.deptId = i.deptId
        this.deptName = i.deptName
        this.deptPicker = false
      },
      goLook(){
        console.log('ss')
      },
      getTypeStu(){
        this.http.getRequest({
          url:'app/userInfo/findTypeList',
          msg:{},
          success:(res)=>{
            this.columnType = res.data
          }
        })
      },
      getMajor(i){
        this.http.getRequest({
          url:'app/userInfo/findMajorList',
          msg:{userTypeId:i},
          success:(res)=>{
            this.columnExam = res.data
          }
        })
      },
      //      学科下拉
      getSub(i){
        this.http.getRequest({
          url: 'app/userInfo/findUserSubjectList',
          msg: {majorId:i},
          success: (res) => {
            this.columnSub = res
          }
        })
      },
      getTenant(){
        this.http.getRequest({
          url:'app/userInfo/tenantNoLogin',
          msg:{},
          success:(res)=>{
            this.showDept = res.data.showDept
            this.showRegister = res.data.showRegister
            this.major = res.data.showMajor
            this.type = res.data.showType
            this.showSubject = res.data.showSubject
            this.fileOnOff = res.data.fileOnOff
            this.fileNotNull = res.data.fileNotNull
            if(this.showDept==1){
              this.getDeptList()
            }
          }
        })
      },
      getDeptList(){
        this.http.getRequest({
          url:'app/userInfo/getDeptList',
          msg:{},
          success:(res)=>{
            if(res.data){
              let arr = res.data
              arr.forEach((item)=>{
                delete item.children
              })
              this.deptList = arr
            }
          }
        })
      },
      afterRead(e){
        let msg = new FormData()
        msg.append('file', e.file)
        this.http.postRequest({
          headers: {'Content-Type': 'multipart/form-data'},
          url: 'app/userInfo/upload',
          msg: msg,
          special: true
        }, true).then((res) => {
          if (res.code == 200) {
            this.form.attachPath = res.url
            this.fileStr = res.fileName
          } else {
            this.utils.toastNone(res.msg || res.code)
          }
        })
      },
      beforeRead(e){
        if(e.length>1){
          this.utils.toastError('只上传一个附件！')
          return false
        }
        if(e.size>20971520){
          this.utils.toastError('文件大小不能超过20MB！')
          return false
        }
        return true
      },
      del(){
        if(this.fileStr){
          this.fileStr = ''
          this.form.attachPath = ''
        }
      }
    },
    mounted () {
     
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  @import "~@/assets/css/variable.less";
  .m-box{
    .m-btn{
      width: 210px;
      margin-top: 48px;
    }
  }
  /deep/.van-uploader{
    width: 100%!important;
  }
  /deep/.van-uploader__input-wrapper{
    width: 100% !important;
  }
  .m-icon{
    position: absolute;
    right: 10px;
    top: 15px;
    color: #969799;
    z-index: 1000;
  }
</style>

